import * as NaturalAddOneDigitNoCarryTask from "./podtemat1_dodawanie_odejmowanie_types/NaturalAddOneDigitNoCarryTask";
import * as NaturalAddTwoDigitNoCarryTask from "./podtemat1_dodawanie_odejmowanie_types/NaturalAddTwoDigitNoCarryTask";
import * as NaturalAddOneDigitCarryTask from "./podtemat1_dodawanie_odejmowanie_types/NaturalAddOneDigitCarryTask";
import * as NaturalAddTwoDigitCarryTask from "./podtemat1_dodawanie_odejmowanie_types/NaturalAddTwoDigitCarryTask";
import * as NaturalSubOneDigitNoBorrowTask from "./podtemat1_dodawanie_odejmowanie_types/NaturalSubOneDigitNoBorrowTask";
import * as NaturalSubTwoDigitNoBorrowTask from "./podtemat1_dodawanie_odejmowanie_types/NaturalSubTwoDigitNoBorrowTask";
import * as NaturalSubTeenBorrowTask from "./podtemat1_dodawanie_odejmowanie_types/NaturalSubTeenBorrowTask";
import * as NaturalSubTwoDigitBorrowTask from "./podtemat1_dodawanie_odejmowanie_types/NaturalSubTwoDigitBorrowTask";

export const registry = {
  NaturalAddOneDigitNoCarryTask,
  NaturalAddTwoDigitNoCarryTask,
  NaturalAddOneDigitCarryTask,
  NaturalAddTwoDigitCarryTask,
  NaturalSubOneDigitNoBorrowTask,
  NaturalSubTwoDigitNoBorrowTask,
  NaturalSubTeenBorrowTask,
  NaturalSubTwoDigitBorrowTask,
};

export function generateTasks() {
  return [
    NaturalAddOneDigitNoCarryTask.generateTask(),
    NaturalAddTwoDigitNoCarryTask.generateTask(),
    NaturalAddOneDigitCarryTask.generateTask(),
    NaturalAddTwoDigitCarryTask.generateTask(),
    NaturalSubOneDigitNoBorrowTask.generateTask(),
    NaturalSubTwoDigitNoBorrowTask.generateTask(),
    NaturalSubTeenBorrowTask.generateTask(),
    NaturalSubTwoDigitBorrowTask.generateTask(),
  ];
}

export function renderTask(task) {
  const m = registry[task.type];
  return m ? m.renderTask(task) : null;
}

export function renderInput(task, userAnswer, onChange, disabled) {
  const m = registry[task.type];
  return m ? m.renderInput(task, userAnswer, onChange, disabled) : null;
}

export function checkAnswer(task, userAnswer) {
  const m = registry[task.type];
  return m ? m.checkAnswer(task, userAnswer) : false;
}

export function renderAnswer(task) {
  const m = registry[task.type];
  return m ? m.renderAnswer(task) : null;
}

export function renderExplanation(task) {
  const m = registry[task.type];
  return m ? m.renderExplanation(task) : null;
}

export function renderUserAnswer(task, userAnswer) {
  const m = registry[task.type];
  return m && m.renderUserAnswer ? m.renderUserAnswer(userAnswer) : null;
}

const naturalAddSubtopic = {
  registry,
  generateTasks,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};

export default naturalAddSubtopic;
